import * as React from 'react';
import { registerIcons } from '@fluentui/style-utilities';
import { createSvgIcon } from 'owa-fluent-icons-svg/lib/createSvgIcon';

export default 'TextColorPickerIcon';

const TextColorPickerIcon = createSvgIcon({
    Svg: props => (
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.4597 1.30304C8.38091 1.1192 8.20014 1 8.00013 1C7.80011 1 7.61935 1.1192 7.54056 1.30304L4.54056 8.30304C4.43178 8.55686 4.54935 8.85079 4.80317 8.95957C5.05698 9.06835 5.35092 8.95078 5.4597 8.69696L6.18697 7H9.81329L10.5406 8.69696C10.6493 8.95078 10.9433 9.06835 11.1971 8.95957C11.4509 8.85079 11.5685 8.55686 11.4597 8.30304L8.4597 1.30304ZM9.38472 6H6.61554L8.00013 2.7693L9.38472 6Z" />
            <path d="M2 11.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 012 13.5v-2z"></path>
        </svg>
    ),
    displayName: 'TextColorPickerIcon',
});

registerIcons({
    icons: {
        TextColorPickerIcon: <TextColorPickerIcon />,
    },
});
